import { AxiosResponse } from "axios";
import { toast } from "react-hot-toast";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  enableCompanyDailyMessageLimitFailure,
  enableCompanyDailyMessageLimitSuccess,
} from "../slices/features/updateCompany";
import { RequestTypes } from "../types";

const updateCompanyService = new AppService();

function* enableCompanyDailyMessageLimit(action: any) {
  const { payload } = action;
  const { id, data } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      updateCompanyService.enableCompanyDailyMessageLimit,
      baseUrl,
      id,
      data
    );

    toast.success(
      `Company daily message limit ${data.enabled ? "enabled" : "disabled"} successfully!`
    );

    yield put(enableCompanyDailyMessageLimitSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess();
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const {
      data: {
        errors: { message },
      },
    } = error;

    toast.error(Array.isArray(message) ? message[0] : message);

    yield put(enableCompanyDailyMessageLimitFailure({ statusCode, statusText }));
  }
}

export function* watchEnableCompanyDailyMessageLimit() {
  yield takeLatest(RequestTypes.ENABLE_COMPANY_DAILY_MESSAGE_LIMIT, enableCompanyDailyMessageLimit);
}
